import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async getIssue({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getIssue', () =>
      http.get(`issue/GetIssue?id=${id}`)
    )
    commit(types.SET_ISSUE, r.data)
  },
  async getIssues({ commit, dispatch }, searchOptions, id) {
    const r = await startLoading(dispatch, 'getIssues', () =>
      http.get(`issue/GetIssues`, {
        params: searchOptions
      })
    )
    commit(types.SET_ISSUES, r.data)
  },
  async updateIssue({ commit, state, dispatch }, issue) {
    await startLoading(dispatch, 'upsertIssue', () =>
      http.post(`issue/UpdateIssue`, issue)
    )
    commit(types.UPDATE_ISSUE, issue)
  },
  async createIssue({ commit, state, dispatch }, issue) {
    await startLoading(dispatch, 'upsertIssue', () =>
      http.post(`issue/CreateIssue`, issue)
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/issues/actions.js